<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>Raferral Employee Tracking</h1>
        <v-divider class="py-3"></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-sheet elevation="1" class="pa-4 mb-6">
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="referralTracks">
              <template v-slot:item.employeeId="{ item }">
                <a :href="`https://rayoga.marianatek.com/admin/employees/edit/${item.employeeId}/personal-information`" target="_blank">
                  {{item.employeeId}}
                </a>
              </template>
              <template v-slot:item.customerId="{ item }">
                <a :href="`https://rayoga.marianatek.com/admin/user/profile/${item.customerId}/purchases`" target="_blank">
                  {{item.customerId}}
                </a>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{formatDate(item.createdAt)}}
              </template>
            </v-data-table>
          </v-col>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'

export default {
  name: 'AnalyticsLandingPage',

  components: {
  },

  data() {
    return {
      headers: [
        {
          text: 'Campaign',
          value: 'campaignId',
        },
        {
          text: 'Employee',
          value: 'employeeId',
        },
        {
          text: 'Customer',
          value: 'customerId',
        },
        {
          text: 'Created',
          value: 'createdAt',
        },
      ]
    }
  },

  computed: {
    ...mapGetters({
      referralTracks: 'referral-page-track/list',
    }),
    langingItemsLoading() {
      return this.$store.state['referral-page-track'].isFindPending
    },
  },

  methods: {
    formatDate(date) {
      return DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_MED)
    }
  },

  mounted() {
    this.$store.dispatch('referral-page-track/find', {
      query: {
        $limit: 500,
        $sort: {updatedAt: -1 },
      }
    })
  }
}
</script>

<style lang="scss">

</style>